<template>
  <el-container type="flex" class="main_container">
    <base-header>
      <div class="a-title">
        <div>
        </div>
      </div>
    </base-header>
    <el-main>
      <el-table :data="takeAwayList" height="100%" v-loading="tableLoading" >
        <el-table-column label="userID" width="120">
          <template v-slot="scope">
            <div>
              {{scope.row.client_id}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="微信头像和昵称" width="120">
          <template v-slot="scope">
            <div>
              <img :src=scope.row.avatar_url />
              {{scope.row.nickname}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="店铺名称" width="120">
          <template v-slot="scope">
            <div>
              {{scope.row.station_name}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="打印机编号" width="120">
          <template v-slot="scope">
            <div
              class="clickable"
              v-show="!scope.row.changingPrinter"
              @click="showPrinterInput(scope.row, scope.$index)"
            >
              {{scope.row.printer_no}}
              <span style="color: dodgerblue;">换绑</span>
            </div>
            <el-input
              v-if="scope.row.changingPrinter"
              style="width: 80px;"
              v-model="printer_no"
              @blur="scope.row.changingPrinter = false"
              @change="changePrinter(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column label="店铺序号" width="120">
          <template v-slot="scope">
            <div>
              {{scope.row.shop_no}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="店铺地址" width="120">
          <template v-slot="scope">
            <div>
              {{scope.row.station_address}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="联系人名称" width="120">
          <template v-slot="scope">
            <div>
              {{scope.row.contact_name}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="手机号码" width="120">
          <template v-slot="scope">
            <div>
              {{scope.row.phone}}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination :total="totalCount" :page-size="pagesize" :current-page="page" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import pageMixin from '../../../mixins/page'
import getTokenMixin from '../../../mixins/getToken'

export default {
  name: 'TakeAwayList',
  mixins: [pageMixin, getTokenMixin],
  data () {
    return {
      getTakeAwayUrl: this.getDomain() + 'bmuser/get_store_seller_list',
      takeAwayList: [],
      tableLoading: true,
      printer_no: undefined
    }
  },
  methods: {
    getList () {
      this.tableLoading = true
      let params = {
        page: this.page,
        pagesize: this.pagesize
      }
      let handle = res => {
        this.takeAwayList = res.data.content.data
        this.totalCount = res.data.content.total_count
        this.takeAwayList.forEach(item => {
          this.$set(item, 'changingPrinter', !item.printer_no)
        })
      }
      let loadings = () => {
        this.tableLoading = false
      }
      this.__axios(this.getTakeAwayUrl, params, handle, loadings)
    },
    showPrinterInput (row, index) {
      this.takeAwayList.forEach(item => {
        item.changingPrinter = false
      })
      row.changingPrinter = true
    },
    changePrinter (row) {
      if (this.printer_no) {
        let params = {
          printer_no: this.printer_no,
          client_id: row.client_id
        }
        let handle = () => {
          this.$message.success('绑定成功')
          row.printer_no = this.printer_no
          this.printer_no = undefined
          row.changingPrinter = false
        }
        this.__axios(this.getDomain() + 'bmuser/add_printer', params, handle)
      } else {
        row.changingPrinter = false
      }
    }
  },
  created () {
    this.getList()
  }
}
</script>

<style scoped>
  span {
    color: #3a8ee6;
    cursor: pointer;
  }

  img {
    width: 30px;
    height: 30px;
  }

  .a-title {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
</style>
